import { render, staticRenderFns } from "./ActionsObservedSingleChat.vue?vue&type=template&id=391d0340&"
import script from "./ActionsObservedSingleChat.vue?vue&type=script&lang=js&"
export * from "./ActionsObservedSingleChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports